import React, { Fragment, useState } from "react";
import { Link } from "gatsby";
import { Link as LinkScroll } from "react-scroll";
import { slug } from "../utils";
import Popup from "./Popup";

const ArrowSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="arrow-icon"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0 -18" />
      <path d="M16 12l-4 -4" />
      <path d="M16 12h-8" />
      <path d="M12 16l4 -4" />
    </svg>
  );
};

const Button = ({
  text,
  btnType,
  linkType,
  link,
  cls = "",
  border = "bordered-yellow",
  submit = false,
  disable = false,
}) => {
  const cleanLink = link?.replace(/\s+/g, "");
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  if (linkType === "internal") {
    return (
      <Link
        to={slug(cleanLink)}
        className={`main-btn ${cls} ${
          btnType === "primary" ? "btn-yellow" : `bordered-btn ${border}`
        } `}
      >
        {text}
        <ArrowSvg />
      </Link>
    );
  } else if (linkType === "external") {
    return (
      <a
        href={cleanLink}
        className={`main-btn ${cls} ${
          btnType === "primary" ? "btn-yellow" : `bordered-btn ${border}`
        } `}
        target="_blank"
      >
        {text}
        <ArrowSvg />
      </a>
    );
  } else if (linkType === "id") {
    return (
      <LinkScroll
        to={cleanLink}
        smooth
        offset={-100}
        duration={750}
        className={`main-btn cursor-pointer ${cls} ${
          btnType === "primary" ? "btn-yellow" : `bordered-btn ${border}`
        } `}
      >
        {text}
        <ArrowSvg />
      </LinkScroll>
    );
  } else if (linkType === "popup") {
    return (
      <Fragment>
        <button
          onClick={() => setIsPopupOpen(true)}
          className={`main-btn ${cls} ${
            btnType === "primary" ? "btn-yellow" : `bordered-btn ${border}`
          } `}
          type={"button"}
        >
          {text}
        </button>
        <Popup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
      </Fragment>
    );
  } else {
    return (
      <button
        className={`main-btn ${cls} ${
          btnType === "primary" ? "btn-yellow" : `bordered-btn ${border}`
        } `}
        type={submit ? "submit" : "button"}
        disabled={disable}
      >
        {text}
        <ArrowSvg />
      </button>
    );
  }
};

export default Button;

export const Button2 = ({
  text,
  btnType,
  linkType,
  link,
  file,
  cls = "",
  border = "bordered-black",
  submit = false,
  disable = false,
}) => {
  if (linkType === "internal") {
    return (
      <Link
        to={slug(link)}
        className={`main-btn ${cls} ${
          btnType === "primary" ? "btn-secondary" : `bordered-btn ${border}`
        } `}
      >
        {text}
        <ArrowSvg />
      </Link>
    );
  } else if (linkType === "external") {
    return (
      <a
        href={link}
        className={`main-btn ${cls} ${
          btnType === "primary" ? "btn-secondary" : `bordered-btn ${border}`
        } `}
        target="_blank"
      >
        {text}
        <ArrowSvg />
      </a>
    );
  } else if (linkType === "upload") {
    return (
      <a
        href={file.asset.url}
        className={`main-btn ${cls} ${
          btnType === "primary" ? "btn-secondary" : `bordered-btn ${border}`
        } `}
        target="_blank"
      >
        {text}
        <ArrowSvg />
      </a>
    );
  } else {
    return (
      <button
        className={`main-btn ${cls} ${
          btnType === "primary"
            ? "btn-secondary"
            : "bordered-btn bordered-white"
        } `}
        type={submit ? "submit" : "button"}
        disabled={disable}
      >
        {text}
        <ArrowSvg />
      </button>
    );
  }
};
